export const downloadAttachment = (data) => {
  for (const value of Object.values(data)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item.url) {
          const linkSource = `${item.url}`;
          const downloadLink = document.createElement("a");
          const fileName = `${item.name}`;
          downloadLink.href = linkSource;
          downloadLink.title = fileName;
          downloadLink.download = fileName;
          downloadLink.target = "_blank";
          downloadLink.click();
        }
      }
    }
  }
};
